import request, { ObjectOptions } from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { mapUserCartRequest, mapUserCartResponse } from './userCartMappers'
export type UserCartRequest = paths['/api/carts/{version}/mycart']['put']['parameters']['body']['payload']
export type UserCartResponse = paths['/api/carts/{version}/mycart']['get']['responses']['200']['content']['application/json']
export type UserCartResponseState = Omit<App.UserCartState, 'synced' | 'fetching'>

export async function getUserCart(accessToken?: string): Promise<UserCartResponseState> {
  let options: ObjectOptions = { credentials: 'include' }
  if (accessToken) {
    options = { headers: { authorization: `Bearer ${accessToken}` } }
  }
  return mapUserCartResponse(await request.get<UserCartResponse>('/api/carts/v2/mycart', options))
}

export function putUserCart(userCartState: App.UserCartState) {
  return request.put('/api/carts/v2/mycart', mapUserCartRequest(userCartState), { credentials: 'include' })
}
